<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main.vue'
import baseMixin from '@/mixins/baseMixin'
import CommentMenu from '@/components/comments/comment-menu.vue'
import { mapState } from 'vuex'

export default {
  components: {
    Layout,
    CommentMenu,
  },
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: appConfig.description }],
    }
  },
  mixins: [baseMixin],
  props: {
    candidateId: {
      type: String,
      required: true,
      default: '',
    },
  },
  computed: {
    ...mapState('comments', {
      filters: (state) => state.cached.candidate.filters,
      pageSize: (state) => state.cached.pagination.pageSize,
    }),
    candidateComments() {
      return this.candidateId
        ? this.$store.getters['comments/getComments'](this.candidateId)
        : []
    },
  },
  watch: {
    filters: {
      handler: 'refreshData',
      deep: true,
    },
    pageSize: 'refreshData',
  },
  async mounted() {
    this.$store.commit('comments/SET_CACHED_STATE', {
      key: 'module',
      value: 'candidate',
    })
    await this.$store.dispatch('comments/commentsInit', this.candidateId)
  },
  methods: {
    async refreshData() {
      this.$store.commit('comments/INCREMENT_LOADING')
      this.$store.commit('comments/RESET_PAGINATION')
      this.$store.commit('comments/CLEAR_COMMENT_PAGES', this.candidateId)
      await this.$store.dispatch('comments/getComments', this.candidateId)
      this.$store.commit('comments/DECREMENT_LOADING')
    },
  },
}
</script>

<template>
  <Layout>
    <v-row justify="center">
      <v-col cols="12" md="11" xl="8">
        <CommentMenu
          :comments="candidateComments"
          :candidate-id="candidateId"
        />
      </v-col>
    </v-row>
  </Layout>
</template>
